import Alpine    from 'alpinejs';
import collapse   from '@alpinejs/collapse';
import intersect  from '@alpinejs/intersect';

import './accordion.js';
import './ai-assistant.js';
import './carousel.js';
import './compare-page.js';
import './design-gallery.js';
import './discover-tabs.js';
import './facet-alpine-reinit.js';
import './facet-search-persist.js';
import './flip-cards.js';
import './front-page-equipment.js';
import './full-bleed-video.js';
import './gallery-reveal.js';
import './mobile-nav.js';
import './nav-accordion.js';
import './newsletter-form.js';
import './product-categories-crop.js';
import './product-subnav.js';
import './product-triptych.js';
import './rendering-lightbox.js';
import './sales-territory-finder.js';
import './search-toggle.js';
import './service-center-finder.js';
import './site-header-height.js';
import './slick.js';
import './video-lightbox.js';

window.Alpine = Alpine;

Alpine.plugin( collapse );
Alpine.plugin( intersect );

Alpine.store( 'equipmentPopup', { active: null });

Alpine.start();
